import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  joinToString1cxrrlmo0chqs as joinToString,
  lastOrNull1aq5oz189qoe1 as lastOrNull,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { EmptySerializersModule991ju6pz9b79 as EmptySerializersModule } from '../modules/SerializersModuleBuilders.mjs';
import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../SerializationExceptions.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import {
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Char19o2r8palgjof as Char } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  decodeSerializableElement$defaulthisepbk9rprr as decodeSerializableElement$default,
  decodeSerializableValue3h7ajfesxzjda as decodeSerializableValue,
  decodeSequentially27kmi8jnnsnbc as decodeSequentially,
  decodeCollectionSize3l4gjp9ef5h8u as decodeCollectionSize,
  Decoder23nde051s631g as Decoder,
  CompositeDecoder2tzm7wpwkr0og as CompositeDecoder,
} from '../encoding/Decoding.mjs';
import { get_lastIndex1yw0x4k50k51w as get_lastIndex } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var NamedValueDecoderClass;
function NamedValueDecoder() {
  if (NamedValueDecoderClass === VOID) {
    class $ extends TaggedDecoder() {
      n27(_this__u8e3s4, index) {
        return this.p27(this.o27(_this__u8e3s4, index));
      }
      p27(nestedName) {
        var tmp0_elvis_lhs = this.s27();
        return this.t27(tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs, nestedName);
      }
      o27(descriptor, index) {
        return descriptor.b1q(index);
      }
      t27(parentName, childName) {
        var tmp;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(parentName) === 0) {
          tmp = childName;
        } else {
          tmp = parentName + '.' + childName;
        }
        return tmp;
      }
      u27() {
        return this.q27_1.n1() ? '$' : joinToString(this.q27_1, '.', '$.');
      }
    }
    initMetadataForClass($, 'NamedValueDecoder');
    NamedValueDecoderClass = $;
  }
  return NamedValueDecoderClass;
}
function tagBlock($this, tag, block) {
  $this.i28(tag);
  var r = block();
  if (!$this.r27_1) {
    $this.j28();
  }
  $this.r27_1 = false;
  return r;
}
var TaggedDecoderClass;
function TaggedDecoder() {
  if (TaggedDecoderClass === VOID) {
    class $ {
      constructor() {
        var tmp = this;
        // Inline function 'kotlin.collections.arrayListOf' call
        tmp.q27_1 = ArrayList().p2();
        this.r27_1 = false;
      }
      h1s() {
        return EmptySerializersModule();
      }
      v27(tag) {
        throw SerializationException().w1o(toString(getKClassFromExpression(this)) + " can't retrieve untyped values");
      }
      w27(tag) {
        return true;
      }
      x27(tag) {
        var tmp = this.v27(tag);
        return typeof tmp === 'boolean' ? tmp : THROW_CCE();
      }
      y27(tag) {
        var tmp = this.v27(tag);
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      z27(tag) {
        var tmp = this.v27(tag);
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      a28(tag) {
        var tmp = this.v27(tag);
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      b28(tag) {
        var tmp = this.v27(tag);
        return typeof tmp === 'bigint' ? tmp : THROW_CCE();
      }
      c28(tag) {
        var tmp = this.v27(tag);
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      d28(tag) {
        var tmp = this.v27(tag);
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      e28(tag) {
        var tmp = this.v27(tag);
        return tmp instanceof Char() ? tmp.f4_1 : THROW_CCE();
      }
      f28(tag) {
        var tmp = this.v27(tag);
        return typeof tmp === 'string' ? tmp : THROW_CCE();
      }
      g28(tag, enumDescriptor) {
        var tmp = this.v27(tag);
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      h28(tag, inlineDescriptor) {
        // Inline function 'kotlin.apply' call
        this.i28(tag);
        return this;
      }
      q1r(deserializer, previousValue) {
        return this.r1r(deserializer);
      }
      p1r(descriptor) {
        return this.h28(this.j28(), descriptor);
      }
      d1r() {
        var tmp0_elvis_lhs = this.s27();
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return false;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var currentTag = tmp;
        return this.w27(currentTag);
      }
      e1r() {
        return null;
      }
      f1r() {
        return this.x27(this.j28());
      }
      g1r() {
        return this.y27(this.j28());
      }
      h1r() {
        return this.z27(this.j28());
      }
      i1r() {
        return this.a28(this.j28());
      }
      j1r() {
        return this.b28(this.j28());
      }
      k1r() {
        return this.c28(this.j28());
      }
      l1r() {
        return this.d28(this.j28());
      }
      m1r() {
        return this.e28(this.j28());
      }
      n1r() {
        return this.f28(this.j28());
      }
      o1r(enumDescriptor) {
        return this.g28(this.j28(), enumDescriptor);
      }
      s1r(descriptor) {
        return this;
      }
      t1r(descriptor) {
      }
      u1r(descriptor, index) {
        return this.x27(this.n27(descriptor, index));
      }
      v1r(descriptor, index) {
        return this.y27(this.n27(descriptor, index));
      }
      w1r(descriptor, index) {
        return this.z27(this.n27(descriptor, index));
      }
      x1r(descriptor, index) {
        return this.a28(this.n27(descriptor, index));
      }
      y1r(descriptor, index) {
        return this.b28(this.n27(descriptor, index));
      }
      z1r(descriptor, index) {
        return this.c28(this.n27(descriptor, index));
      }
      a1s(descriptor, index) {
        return this.d28(this.n27(descriptor, index));
      }
      b1s(descriptor, index) {
        return this.e28(this.n27(descriptor, index));
      }
      c1s(descriptor, index) {
        return this.f28(this.n27(descriptor, index));
      }
      d1s(descriptor, index) {
        return this.h28(this.n27(descriptor, index), descriptor.e1q(index));
      }
      e1s(descriptor, index, deserializer, previousValue) {
        var tmp = this.n27(descriptor, index);
        return tagBlock(this, tmp, () => this.q1r(deserializer, previousValue));
      }
      g1s(descriptor, index, deserializer, previousValue) {
        var tmp = this.n27(descriptor, index);
        return tagBlock(this, tmp, () => {
          // Inline function 'kotlinx.serialization.encoding.decodeIfNullable' call
          var isNullabilitySupported = deserializer.b1n().q1p();
          var tmp;
          if (isNullabilitySupported || this.d1r()) {
            tmp = this.q1r(deserializer, previousValue);
          } else {
            tmp = this.e1r();
          }
          return tmp;
        });
      }
      s27() {
        return lastOrNull(this.q27_1);
      }
      i28(name) {
        this.q27_1.j2(name);
      }
      j28() {
        var r = this.q27_1.a5(get_lastIndex(this.q27_1));
        this.r27_1 = true;
        return r;
      }
    }
    protoOf($).f1s = decodeSerializableElement$default;
    protoOf($).r1r = decodeSerializableValue;
    protoOf($).i1s = decodeSequentially;
    protoOf($).k1s = decodeCollectionSize;
    initMetadataForClass($, 'TaggedDecoder', VOID, VOID, [Decoder(), CompositeDecoder()]);
    TaggedDecoderClass = $;
  }
  return TaggedDecoderClass;
}
//region block: exports
export {
  NamedValueDecoder as NamedValueDecoderzk26ztf92xbq,
};
//endregion

//# sourceMappingURL=Tagged.mjs.map
